module.exports = Object.freeze({
  own: 'own',
  thirdParty: 'third_party'
});
